<template>
  <div>
    <div class="page-header" filter-color="black">
      <parallax
        class="page-header-image"
        v-bind:style="background"
      >
      </parallax>
      <div class="container">
        <div class="content-center">
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <h2>{{project.name}}</h2>
          <h4>{{project.summary}}</h4>
          <h4><strong>Oferta ${{project.ammount_total}}</strong></h4>
          <br><br>
          <router-link v-if="showInvetButton"
                  :to="{ name: 'invest', params: { id: projectId }}"
                  class="btn btn-round btn-neutral btn-lg" type="neutral"
                >
                {{$t('index.button_investment')}}
          </router-link>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="container-fluid text-center">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Prospecto del proyecto</h2>
            <pdf
                v-for="i in numPages"
                :key="i"
                :src="urlPdf"
                :page="i"
                style="margin-top: 10px"
            ></pdf>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax, Modal, Button } from '@/components';
import Investments from '@/providers/Investments'
const provider = new Investments()
import pdf from 'vue-pdf'

export default {
  name: 'project-detail',
  bodyClass: 'index-page',
  components: {
    Parallax,
     Modal,
     [Button.name]: Button,
     pdf
  },
  mounted() {
    if (this.$route.params.id) {
      this.getProject()
    } else {
      this.$router.push({name: 'index'})
    }
  },
  data() {
    return {
      projectId: this.$route.params.id,
      project: {},
      background: "",
      showInvetButton: (this.$store.state.user ? true : false),
      urlPdf: null,
      currentPage: 0,
      pageCount: 0,
      numPages: undefined
    }
  },
  methods: {
    getProject() {
      if (this.$route.params.id) {
        provider.getInvestmentPublic(this.$route.params.id).then((response) => {
          let data = response.data.data
          if(data && data.attributes) {
            this.project = data.attributes
            
            if(data.attributes.thumbnails && data.attributes.thumbnails.length > 0) {
              const t = data.attributes.thumbnails[0];
              let url = this.$store.state.api_files + t.id
              this.background = "background-image:url('"+ url + "')"
            }
            
            if(data.attributes.documents && data.attributes.documents.length > 0) {
              const t = data.attributes.documents[0];
              try {
                this.urlPdf = this.$store.state.api_files + t.id
                pdf.createLoadingTask(this.urlPdf).promise.then(pdf => {
                    this.numPages = pdf.numPages;
                });
                
              } catch (error) {
                console.info('error build pdf')
                console.info(error)
              }
            }
          }
        }).catch((err) => {
          console.info('error get project request')
          console.info(err)
        })
      }
    }
  }
};
</script>
<style>
</style>
